export default __webpack_public_path__ + "static/media/organisation-white.fab91332.svg";